import apiClient from './AuthService';

// Types based on backend API
export interface SpatialExperienceRessoConfigChallenge {
  spatial_experience_resso_config_challenge_id?: string;
  project_id: string;
  user_id?: string;
  label: string;
  coords: string;
  created_at?: string;
  updated_at?: string;
}

export interface SpatialExperienceRessoConfigChallengeResponse {
  spatial_experience_resso_config_challenge_id: string;
  message: string;
}

export interface SpatialExperienceRessoConfigChallengeData {
  data: SpatialExperienceRessoConfigChallenge | SpatialExperienceRessoConfigChallenge[];
}

// Create a new challenge entry
export const saveSpatialExperienceRessoConfigChallenge = async (
  projectId: string,
  label: string,
  coords: string
): Promise<SpatialExperienceRessoConfigChallengeResponse> => {
  try {
    const requestData = {
      project_id: projectId,
      label,
      coords
    };

    console.log('📤 Sending SpatialExperienceRessoConfig data:', requestData);

    const response = await apiClient.post<SpatialExperienceRessoConfigChallengeResponse>(
      '/quiz/spatial-experience-resso-config-challenge',
      requestData
    );

    console.log('✅ SpatialExperienceRessoConfig saved successfully:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ SpatialExperienceRessoConfig API Error:', {
      status: error.response?.status,
      data: error.response?.data,
      fullError: error
    });

    if (error.response?.data?.error && typeof error.response.data.error === 'string') {
      throw new Error(error.response.data.error);
    } else if (error.response?.data?.message && typeof error.response.data.message === 'string') {
      throw new Error(error.response.data.message);
    } else if (error.response?.data && typeof error.response.data === 'string') {
      throw new Error(error.response.data);
    }

    throw new Error('Error al guardar el challenge. Por favor, intenta de nuevo.');
  }
};

// Get a single challenge by ID
export const getSpatialExperienceRessoConfigChallenge = async (
  challengeId: string
): Promise<SpatialExperienceRessoConfigChallenge> => {
  try {
    const response = await apiClient.get<SpatialExperienceRessoConfigChallengeData>(
      `/quiz/spatial-experience-resso-config-challenge/${challengeId}`
    );
    return response.data.data as SpatialExperienceRessoConfigChallenge;
  } catch (error: any) {
    console.error('❌ getSpatialExperienceRessoConfigChallenge error:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

// Get all challenges for a project
export const getProjectSpatialExperienceRessoConfigChallenges = async (
  projectId: string
): Promise<SpatialExperienceRessoConfigChallenge[]> => {
  try {
    console.log('📡 Fetching spatial experience resso config challenges for project:', projectId);
    const response = await apiClient.get<SpatialExperienceRessoConfigChallengeData>(
      `/quiz/project/${projectId}/spatial-experience-resso-config-challenges`
    );

    const data = response.data.data;
    if (!Array.isArray(data)) {
      return data ? [data] : [];
    }
    return data;
  } catch (error: any) {
    console.error('❌ getProjectSpatialExperienceRessoConfigChallenges error:', error);

    if (error.response?.status === 404) {
      console.log('📡 No challenges found for project (404), returning empty array');
      return [];
    }

    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};
